import { useMemo } from "react";
import { useQuery } from "@apollo/client/react";
import { connectionRows, type StageRow, StagesByWorkflowDocument } from "#app/lib/data";

export function useWorkflowStages(workflowId: string | undefined): {
  stages: StageRow[];
  loading: boolean;
} {
  const variables = useMemo(
    () => ({ workflowId: workflowId! }),
    [workflowId],
  );
  const { data, loading } = useQuery(StagesByWorkflowDocument, {
    variables,
    skip: !workflowId,
  });
  const stages = useMemo(() => connectionRows(data?.stages), [data]);
  return { stages, loading };
}
